import { render, staticRenderFns } from "./UnlockUser.vue?vue&type=template&id=4751724a"
import script from "./UnlockUser.vue?vue&type=script&lang=ts"
export * from "./UnlockUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports